<template>
  <div>
    <div class="s_nav">
      <div class="itemBox">
        <div
          class="item"
          :class="{'activeItem':item.status}"
          v-for="(item,index) in titleList"
          @click="navRoute(item.id)"
          :key="index"
        >
          <div class="title" :class="{'active':item.status}">{{item.title}}</div>
          <div class="sTitle" :class="{'active':item.status}">{{item.sTitle}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["titleList"],
  methods: {
    navRoute(id) {
      // console.log(id);
      this.$emit("myFn", id);
    },
  },
};
</script>

<style lang='less'>
.s_nav {
  height: 154px;
  width: 100%;
  background-color: #da261d;
  margin-top: 55px;
  .itemBox {
    display: flex;
    .item {
      flex: 1;
      text-align: center;
      height: 154px;
      .title {
        margin-top: 30px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
        line-height: 60px;
      }
      .sTitle {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
        line-height: 24px;
      }
      .active {
        color: #3c3c3c;
      }
    }
    .activeItem {
      background-color: #eeeeff;
    }
  }
}
</style>